/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useEffect, useState } from "react";
import "../../../assets/styles/custom-style.css";

import { useAuth } from "../../../auth";
import "../../../assets/styles/custom-style.scss";
import { listChefWelletDetail } from "../core/_requests";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "../../../component/Pagination";
import { useFormattedUtils } from "../../../component/dateUtils";

const ViewWalletDetails = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { formatDateUS } = useFormattedUtils();
  const [wallet, setWallet] = useState<any[]>([]); // Initialize with an empty array
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const chefId = currentUser?.uuid;
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const filterData = {
    search: search,
  };

  useEffect(() => {
    listChefWelletDetail(chefId).then((res) => {
      setWallet(res?.data); // Set wallet state with data from the response or an empty array
    });
  }, []);

  //pagination

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = wallet.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(wallet.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= pages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    const isActive = number === currentPage;

    let pageNumberContent;

    if (
      number === 1 ||
      number === pages ||
      (number >= currentPage - 1 && number <= currentPage + 1)
    ) {
      pageNumberContent = (
        <li
          key={number}
          className={`page-item ${number === currentPage ? "active" : ""}`}
        >
          <a
            className={`page-link cursorPointer ${number === currentPage ? "active" : ""
              }`}
            onClick={() => setCurrentPage(number)}
          >
            {number}
          </a>
        </li>
      );
    } else if (number === 2 || number === pages - 1) {
      // Add links for second and second-to-last pages
      pageNumberContent = (
        <li key={number} className="page-item">
          <a
            className="page-link cursorPointer"
            onClick={() => setCurrentPage(number)}
          >
            {number}
          </a>
        </li>
      );
    } else if (number === 3 && currentPage > 4) {
      // Add ellipsis before the link to the second page
      pageNumberContent = (
        <li key={number} className="page-item">
          <span className="ellipsis">...</span>
        </li>
      );
    } else if (number === pages - 2 && currentPage < pages - 3) {
      // Add ellipsis before the link to the second-to-last page
      pageNumberContent = (
        <li key={number} className="page-item">
          <span className="ellipsis">...</span>
        </li>
      );
    }

    return pageNumberContent;
  });

  const nextPage = () => {
    if (currentPage < pages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const listTransaction = () => {
    navigate("/settlements/all-settlement");
  };

  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            {/*  */}
            <section className="row main-content settlement-content">
              {/* <div className="title mb-3 d-flex align-items-center justify-content-between">
                <h3 className="mb-0">Wallet</h3>
                <button
                  className="btn btn-primary btn-ico rounded-5 btn-empty small"
                  onClick={listTransaction}
                >
                  <i className="material-symbols-outlined">history</i>
                  <span>Transaction History</span>
                </button>
              </div> */}

              <div className="col-12">
                <div className="row">
                  <div className="col-12 mt-4 mb-4">
                    <div className="snippet-block">
                      <div className="head">
                        <h6 className="mb-0">Wallet List</h6>
                      </div>
                      {/* Check if wallet array is empty */}
                      {wallet.length === 0 ? (
                        <div className="snippet-content">
                          <div className="no-data">
                            <img
                              className="img-fluid mb-3"
                              src="/assets/images/no-data-img.svg"
                              alt="No Data"
                            />
                            <p className="mb-0 mid-gray">
                              <small>
                                Your Wallet's Feeling Light – Add Funds to Get Started!
                              </small>
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="snippet-content">
                          <table className="table custom-table mb-0">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Type</th>
                                <th>Date</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Balance</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentItems.map(
                                (walletDetail: any, index: any) => (
                                  <tr key={index}>
                                    <td>{indexOfFirstItem + index + 1}</td>
                                   <td>
  <Link
    to={`/settlements/wallet-details/${walletDetail.primaryId}`}
    className="text-decoration-none"
  >
    {(() => {
      switch (walletDetail.walletType) {
        case 1:
          return `Order (${walletDetail?.orderId})`;
        case 2:
          return "Bonus";
        case 3:
          return "Plan Refund";
        case 4:
          return "Debit Subscription";
        case 5:
          return "Subscription Bonus";
        default:
          // If walletType is a string (like from your API)
          return walletDetail.walletType || "Unknown";
      }
    })()}
  </Link>
</td>


                                    <td>{formatDateUS(walletDetail?.date)}</td>
                                    <td>{walletDetail?.debit?.toFixed(2) ?? "0.00"}</td>
                                    <td>{walletDetail?.credit?.toFixed(2) ?? "0.00"}</td>
                                    <td>{walletDetail?.balance?.toFixed(2) ?? "0.00"}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Pagination
                data={wallet}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default ViewWalletDetails;
